import React, { useState } from 'react'
import { Formik } from 'formik'
import {
  Card,
  Checkbox,
  Button,
  Layout,
  Paragraph,
  FormField,
} from '@vwfs-bronson/bronson-react'
import { useTranslation } from 'react-i18next'
import { trustedShopsQuestionnaireLink } from '../../services/api/trustedShops'
import { CustomerHappinessIndexValidationSchema } from '../../services/validation'
import SpinnerElement from '../SpinnerElement'

export default function CustomerHappinessIndex({ transactionId }) {
  const { t } = useTranslation()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const buildLink = index => (
    <a
      key={index}
      href={t(`customerHappinessIndex:legalNotice:link${index}:url`)}
      target="_blank"
      rel="noreferrer"
    >
      {t(`customerHappinessIndex:legalNotice:link${index}:text`)}
    </a>
  )

  return (
    <Formik
      initialValues={{ consent: false }}
      validationSchema={CustomerHappinessIndexValidationSchema}
      onSubmit={async () => {
        try {
          const newTab = window.open('', '_blank')
          setIsSubmitting(true)
          const link = await trustedShopsQuestionnaireLink(transactionId)
          if (!link) {
            newTab?.close()
            return
          }
          if (newTab) {
            newTab.location.href = link
          }
        } finally {
          setIsSubmitting(false)
        }
      }}
    >
      {formikProps => (
        <>
          <SpinnerElement visible={isSubmitting} />
          <Layout center>
            <Layout.Item default="1/1">
              <Card
                ariaLabel={t('customerHappinessIndex:title')}
                title={t('customerHappinessIndex:title')}
                footer
                titleLevel={2}
              >
                <Paragraph>{t('customerHappinessIndex:text')}</Paragraph>
                <Layout.Item default="1/1">
                  <FormField name="consent" type="checkbox">
                    <Layout center>
                      <Checkbox
                        checked={formikProps.values.consent}
                        onChange={e =>
                          formikProps.setFieldValue('consent', e.target.checked)
                        }
                      >
                        {t('customerHappinessIndex:consent')}
                      </Checkbox>
                      <Button
                        type="submit"
                        disabled={!formikProps.values.consent}
                        element="a"
                        href="questionnaire"
                        onClick={formikProps.handleSubmit}
                      >
                        {t('customerHappinessIndex:button')}
                      </Button>
                    </Layout>
                  </FormField>
                </Layout.Item>
              </Card>
            </Layout.Item>
            <Layout.Item default="1/1">
              <Paragraph>
                {t('customerHappinessIndex:legalNotice:paragraph')}
              </Paragraph>
            </Layout.Item>
            <Layout.Item default="1/1">
              <Paragraph>
                {t('customerHappinessIndex:legalNotice:preffix')}
                {buildLink(1)}
                {buildLink(2)}
                {buildLink(3)}
              </Paragraph>
            </Layout.Item>
          </Layout>
        </>
      )}
    </Formik>
  )
}
